"use client";
import { openInvestmentModal } from "@/redux/features/InvestmentModal/investmentModalSlice";
import React from "react";
import { useAppDispatch } from "@/redux/Hooks";
import { Scheme } from "@/type/schemeType";
import { SchemeOptional } from "@/type/commonTypes";

interface InvestButtonProps {
  scheme: SchemeOptional | Scheme;
}

export default function InvestButton({ scheme }: InvestButtonProps) {
  const dispatch = useAppDispatch();

  const formPlayload: SchemeOptional = {
    scheme_code: scheme.scheme_code || "",
    scheme_name: scheme.scheme_name || "",
    amc_code: scheme.amc_code || "",
    sip_allowed: scheme.sip_allowed,
    lump_allowed: scheme.lump_allowed,
    minimum_sip_invest: scheme.minimum_sip_invest,
    minimum_investment: scheme.minimum_investment,
  };

  return (
    <button
      onClick={() => dispatch(openInvestmentModal(formPlayload))}
      className="fixed w-full max-w-fit mx-auto lg:static z-10 left-0 right-0 bottom-7 bg-primaryBlue rounded-10xl text-sm font-medium text-white px-14 py-2.5 transition-all duration-300 ease-in-out hover:bg-[#12418d] hover:scale-[1.01] hover:shadow-[0px_5px_10px_0px_#00000026] shadow-[0px_4px_20px_2px_#00000038] sm:shadow-none"
    >
      Invest Now
    </button>
  );
}
